export enum ReportIssueStatus {
  PENDING = 'PENDING',
  ASSIGNED = 'ASSIGNED',
  CLOSE = 'CLOSE',
}
